import React from 'react';
import {CareerHistoryPreview as Preview} from '@/pages/CareerHistory/';

export const CareerHistoryPreview = (): React.ReactElement => <Preview admin presentation />